<template>
  <div class="sidebar" :class="{ 'sidebar--open': open }">
    <p-button
      icon="fa fa-caret-left"
      class="sidebar__toggle-button p-button-rounded"
      @click="toggle"
    />

    <div class="sidebar__content">
      <div class="sidebar__wrapper">
        <div class="sidebar__section section">
          <div
            class="section__title"
            @click="linkTo(link_selected_lpo_section)"
          >
            Обследование
          </div>

          <ul class="section__list">
            <li
              class="section__list-item"
              :class="{
                'section__list-item--selected': isSelected(
                  link_selected_lpo_section
                ),
              }"
              @click="linkTo(link_selected_lpo_section)"
            >
              <div class="section__list-item-icon">
                <i class="fa fa-home" />
              </div>
              <div class="section__list-item-text">Участок</div>
            </li>
            <li
              class="section__list-item"
              :class="{
                'section__list-item--selected': isSelected(
                  link_selected_lpo_geometry
                ),
              }"
              @click="linkTo(link_selected_lpo_geometry)"
            >
              <div class="section__list-item-icon">
                <i class="fa fa-vector-square" />
              </div>
              <div class="section__list-item-text">Границы и площадь</div>
            </li>
            <li
              class="section__list-item"
              :class="{
                'section__list-item--selected': isSelected(
                  link_selected_lpo_inspection
                ),
              }"
              @click="linkTo(link_selected_lpo_inspection)"
            >
              <div class="section__list-item-icon">
                <i class="fa fa-database" />
              </div>
              <div class="section__list-item-text">Данные обследования</div>
            </li>
            <li
              class="section__list-item"
              :class="{
                'section__list-item--selected': isSelected(
                  link_selected_lpo_result
                ),
              }"
              @click="linkTo(link_selected_lpo_result)"
            >
              <div class="section__list-item-icon">
                <i class="fa fa-clipboard-check" />
              </div>
              <div class="section__list-item-text">Результаты обследования</div>
            </li>
          </ul>
        </div>

        <div class="sidebar__section section">
          <div class="section__title" @click="linkTo(link_lpoList)">
            Акт
          </div>

          <ul class="section__list">
            <li
              class="section__list-item"
              :class="{
                'section__list-item--selected': isSelected(link_lpoList),
              }"
              @click="linkTo(link_lpoList)"
            >
              <div class="section__list-item-icon">
                <i class="fa fa-layer-group" />
              </div>
              <div class="section__list-item-text">Выделы</div>
            </li>
            <li
              class="section__list-item"
              :class="{
                'section__list-item--selected': isSelected(link_lease),
              }"
              @click="linkTo(link_lease)"
            >
              <div class="section__list-item-icon">
                <i class="fa fa-vector-square" />
              </div>
              <div class="section__list-item-text">Аренда</div>
            </li>
            <li
              class="section__list-item"
              :class="{
                'section__list-item--selected': isSelected(link_geometry),
              }"
              @click="linkTo(link_geometry)"
            >
              <!-- 						<li
							class='section__list-item'
							:class='{ "section__list-item--selected": isSelected(link_geometry) }'
						> -->
              <div class="section__list-item-icon"><i class="fa fa-map" /></div>
              <div class="section__list-item-text">Абрис</div>
            </li>

            <li
              class="section__list-item"
              :class="{
                'section__list-item--selected': isSelected(link_uploads),
              }"
              @click="linkTo(link_uploads)"
            >
              <div class="section__list-item-icon">
                <i class="fa fa-camera" />
              </div>
              <div class="section__list-item-text">Материалы фотофиксации и треки</div>
            </li>
          </ul>
        </div>

        <div class="sidebar__section section">
          <div class="section__title">
            Сформировать
          </div>

          <FormReestr class="p-mb-2" />
          <ul class="section__list p-mb-2">
            <li class="section__list-item" @click="openDraftConfirmation">
              <div class="section__list-item-icon">
                <i class="fa fa-lock" />
              </div>
              <div class="section__list-item-text" v-if="!togglingToClear">
                {{
                  actLpoIsDraft
                    ? "Перевести в чистовик"
                    : "Перевести в черновик"
                }}
              </div>
              <p-spinner v-else />
            </li>
          </ul>
          <FormAct />
        </div>

        <div class="sidebar__section section">
          <div class="section__title">
            Дополнительно
          </div>

          <ul class="section__list">
            <li
              class="section__list-item section__list-item--danger"
              @click="openRemoveConfirmation"
            >
              <div class="section__list-item-icon">
                <i class="fa fa-trash" />
              </div>
              <div class="section__list-item-text">Удалить обследование</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <custom-p-confirmation
      v-model="draftConfirmationIsOpen"
      title="Черновик / Чистовик"
      :message="
        'Перевести акт в статус ' +
          (actLpoIsDraft ? 'чистовика' : 'черновика') +
          '?'
      "
      confirmLabel="Да"
      rejectLabel="Отмена"
      @confirm="toggleDraft"
      confirmButtonClass="p-button-success"
    />

    <custom-p-confirmation
      v-model="removeConfirmationIsOpen"
      title="Удаление обследования"
      message="Вы уверены, что хотите удалить данное обследование?"
      confirmLabel="Удалить"
      rejectLabel="Отмена"
      @confirm="removeLpo"
      confirmButtonClass="p-button-danger"
    />
    
    <p-dialog :visible.sync="permissionIsOpen">
        <template #header>
          <h3>Не выполнено</h3>
        </template>

        Недостаточно прав для выполнения операции

        <template #footer>
          <p-button label="Назад" icon="pi pi-times" @click="permissionIsOpen = false" class="p-button-text"/>
        </template>
    </p-dialog>
  </div>
  
</template>

<script>
import { mapState, mapActions } from "vuex";

import FormAct from "./Sidebar__formAct";
import FormReestr from "./Sidebar__formReestr";

import CustomPConfirmation from "@/lib/customComponents/CustomPConfirmation";

import fetchData from "@/lib/fetchData";

const ROOT_API = process.env.VUE_APP_ROOT_API;
const FORM_ACT = ROOT_API + "form_act/index.php";

const GET_TAX = ROOT_API + "get_site_data/get_tax.php";
const GET_ACT_LPO_LIST = ROOT_API + "act_data/get_act_lpo_list.php";
const GET_MAIN_DAMAGE_REASONS =
  ROOT_API + "get_site_data/get_main_damage_reasons.php";
const GET_FREQ_PEST = ROOT_API + "get_site_data/get_freq_pest.php";
const GET_FREQ_DISEASE = ROOT_API + "get_site_data/get_freq_disease.php";
const CHECK_S_PLOT = ROOT_API + "get_site_data/check_s_plot.php";
const GET_MODEL_TREES = ROOT_API + "get_site_data/get_model_trees.php";
const GET_VB_PCT = ROOT_API + "get_site_data/get_vb_pct.php";
const CHECK_PROF_MZL_FITS_SKS =
  ROOT_API + "get_site_data/check_prof_mzl_fits_sks.php";
const CHECK_KPP_TREE_AMOUNT =
  ROOT_API + "get_site_data/check_kpp_tree_amount.php";
const GET_MZL = ROOT_API + 'get_site_data/mzl/get_mzl.php';
const GET_MANUAL_MZL = ROOT_API + 'get_site_data/mzl/get_manual_mzl.php';

export default {
  name: "LpoDataSidebar",

  components: {
    FormAct,
    FormReestr,

    CustomPConfirmation,
  },

  data: () => ({
    open: true,
    permissionIsOpen: false,
    draftConfirmationIsOpen: false,
    removeConfirmationIsOpen: false,

    togglingToClear: false,
  }),

  computed: {
    checkPermissionsToDraft() {
      let perm = false;
      if (this.actLpoList) {
        if(this.actLpoList.map(e => e.user_id).includes(this.user.id)) {
          perm = true;
        }
      }
      if (this.user) {
        if(this.user.permissions.includes("4")) {
          perm = true;
        }
      }
      return perm;
    },
    link_selected_lpo_section() {
      return { name: "current-lpo-section" };
    },
    link_selected_lpo_geometry() {
      return { name: "current-lpo-geometry" };
    },
    link_selected_lpo_inspection() {
      return { name: "current-lpo-inspection" };
    },
    link_selected_lpo_result() {
      return { name: "current-lpo-result" };
    },

    link_lpoList() {
      return { name: "act-lpo-list" };
    },
    link_lease() {
      return { name: "lease" };
    },
    link_geometry() {
      return { name: "geometry" };
    },
    link_uploads() {
      return { name: "upload-materials" };
    },

    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },
    ...mapState("user", {
      user: (state) => state.user,
    }),
    ...mapState("lpoData", {
      currentLpo: (state) => state.currentLpo,
      actLpoList: (state) => state.actLpoList,
    }),
    ...mapState('selectedLpo', {
      mzl: state => state.mzl.mzl,
      manualMzl: state => state.mzl.manualMzl,
    })
  },

  methods: {
    async toggleDraft() {
      if (this.checkPermissionsToDraft) {
        const lpo_id = this.$route.params.lpo_id;

        if (this.actLpoIsDraft) {
          this.togglingToClear = true;

          const lpoList = await this.getLpoList();
          const taxList = await this.getTax(lpoList);

          // const mainDamageList = [];

          for (const lpo of lpoList) {
            // lpo['mainDamageList'] = await this.getMainDamageList(lpo);
            lpo["freqPestList"] = await this.getFreqPest(lpo);
            lpo["freqDiseaseList"] = await this.getFreqDisease(lpo);
            lpo["checkSPlot"] = await this.checkSPlot(lpo);
            lpo["modelTrees"] = await this.getModelTrees(lpo);
            lpo["vbPct"] = await this.getVbPct(lpo);
            lpo["checkProfMzlFitsSks"] = await this.checkProfMzlFitsSks(lpo);
            lpo["checkKppTreeAmount"] = await this.checkKppTreeAmount(lpo);
            lpo["mzl"] = await this.getMzl(lpo);
            lpo["m_mzl"] = await this.getManualMzl(lpo);
          }

          const requiredIncorrect2 = this._checkRequired2(taxList, lpoList);

          let dataIncorrect = false;

          for (const type in requiredIncorrect2) {
            if (!requiredIncorrect2[type].length) {
              continue;
            }

            dataIncorrect = true;
            let requiredIncorrectText =
              `${type}: ` + requiredIncorrect2[type].join(", ");
            this.$toast.add({
              severity: "warn",
              detail: requiredIncorrectText,
              life: 10000,
            });
          }

          if (dataIncorrect) {
            this.togglingToClear = false;
            return;
          }
        }
        
      
        this.$store
          .dispatch("lpoData/TOGGLE_ACT_DRAFT")
          .then((res) => {
            this.$store.dispatch("lpoData/getCurrentLpoData", lpo_id);
          })
          .finally(() => {
            this.togglingToClear = false;
          });
      } else {
        this.permissionIsOpen = true;
      }
    },

    /* ФУНКЦИИ ПРОВЕРОК */
    async getTax(lpoList) {
      const taxList = [];

      for (const lpo of lpoList) {
        const form = new FormData();
        form.append("tax_id", lpo.tax_id);

        const tax = await fetchData(GET_TAX, form).then((res) => {
          return res;
        });
        taxList.push(tax);
      }

      console.log("taxList: ", taxList);
      return taxList;

      const form = new FormData();
      form.append("tax_id", this.currentLpo.tax_id);

      return fetchData(GET_TAX, form).then((res) => {
        return res;
      });
    },
    async getMzl(lpo) {
			const form = new FormData();
			form.append('lpo_id', lpo.lpo_id);
			const response =  await fetch( GET_MZL, { method: 'POST',
        body: form
      });
      const res = await response.json();
      return res?.[0]?.id
		},

    
		async getManualMzl(lpo) {
			const form = new FormData();
			form.append('lpo_id', lpo.lpo_id);

			const response = await fetch( GET_MANUAL_MZL, { method: 'POST',
        body: form
      });
      const res = await response.json();
			return res?.[0]?.mzl_id;
		},
    getLpoList() {
      const form = new FormData();
      form.append("lease_id", this.currentLpo.lease_id);

      return fetchData(GET_ACT_LPO_LIST, form).then((res) => {
        return res;
      });
    },
    getFreqPest(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(GET_FREQ_PEST, form).then((res) => {
        return res.filter((item) => {
          return item.z_degree != "-";
        });
      });
    },
    getFreqDisease(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(GET_FREQ_DISEASE, form).then((res) => {
        return res.filter((item) => item.dmg_degree != "-");
      });
    },
    checkSPlot(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(CHECK_S_PLOT, form).then((res) => {
        return res?.[0].s_plot_enough;
      });
    },
    getModelTrees(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(GET_MODEL_TREES, form).then((res) => {
        return res;
      });
    },
    getVbPct(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(GET_VB_PCT, form).then((res) => {
        return res.czl_get_vb_pct;
      });
    },
    checkProfMzlFitsSks(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(CHECK_PROF_MZL_FITS_SKS, form)
        .then((res) => {
          return res?.[0].czl_check_prof_mzl_fits_sks;
        })
        .catch((err) => {
          return "f";
        });
    },
    checkKppTreeAmount(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(CHECK_KPP_TREE_AMOUNT, form)
        .then((res) => {
          return res?.[0].czl_check_kpp_tree_amount;
        })
        .catch((err) => {
          console.log(err);
          return "f";
        });
    },

    _checkRequired2(taxList, lpoList) {
      const incorrects = {};

      const labelTax = "Таксационное описание";
      incorrects[labelTax] = this._checkTax(taxList);

      // console.log(incorrects);

      for (let i = 0; i < lpoList.length; ++i) {
        const lpo = lpoList[i];

        const labelSection =
          "Выдел " +
          lpo.section +
          (lpo.section_lp ? "(" + lpo.section_lp + ")" : "");

        incorrects[labelSection] = this._checkLpo(lpo, i, taxList);
      }

      return incorrects;
    },

    _checkTax(taxList) {
      const incorrects = [];

      for (const tax of taxList) {
        if (!tax[0].forest_inventory_year) {
          incorrects.push("Год лесоустройства (ТО)");
        }
        if (!tax[0].forest_purpose_id) {
          incorrects.push("Целевое назначение лесов (ТО)");
        }
        if (!tax[0].s) {
          incorrects.push("Площадь лесотаксационного выдела (ТО)");
        }
        if (!tax[0].bonitet_id) {
          incorrects.push("Бонитет (ТО)");
        }
        if (!tax[0].forest_type) {
          incorrects.push("Тип леса (ТО)");
        }

        // if (!tax[0].tlu_id) {
        // 	incorrects.push('ТЛУ (ТО)');
        // }

        if (!tax[0].layer_id) {
          incorrects.push("Ярусы (ТО)");
        }
        if (!tax[0].species_id && !tax[0].non_forest_land_id) {
          incorrects.push("Породы яруса (ТО)");
        }
      }
      return incorrects;
    },

    _checkLpo(lpo, lpoIndex, taxList) {
      const incorrects = [];
      console.log(lpo['mzl'], lpo['m_mzl'])
      if (!lpo.inspection_date) {
        incorrects.push("Дата проведения обследования");
      }

      if (
        lpo.section_lp &&
        (lpo.s_lp === null || lpo.s_lp === "") &&
        (lpo.s_lp_manual === null || lpo.s_lp_manual === "")
      ) {
        incorrects.push("Площадь лесопатологического выдела отсутствует");
      }

      if (lpo.section_lp) {
        const s_lp =
          lpo.s_lp_manual !== null && lpo.s_lp_manual !== ""
            ? +lpo.s_lp_manual
            : +lpo.s_lp;
        if (s_lp > +taxList[lpoIndex][0].s) {
          incorrects.push(
            "Площадь лесопатологического выдела больше площади лесотаксационного выдела"
          );
        }

        console.log("s_lp: ", s_lp);
        console.log("s:", +taxList[lpoIndex][0].s);
      }

      if (['1','2','3','4','5'].includes(lpo.inspection_type_id)) {
        // if (!lpo.mainDamageList.length) {
        // 	incorrects.push('Основная причина повреждения древесины');
        // }
        if (!lpo.critical_density) {
          incorrects.push("Критическая полнота");
        }
        if (lpo.mzl == "-1" && !lpo.m_mzl) {
          incorrects.push("Не выбрано значение в поле СОМ (ручной ввод)");
        }
        if (lpo.mzl != '-1') {
          //console.log(mzl)
          if (!lpo.mzl_period_to && lpo.mzl != '-3') {
            incorrects.push("Рекомендуемый срок проведения мероприятий");
          }
        } else if (lpo.m_mzl) {
          if (!lpo.mzl_period_to && lpo.m_mzl != '-3') {
            incorrects.push("Рекомендуемый срок проведения мероприятий");
          }
        }

        if (!this._isMzlPeriodToCorrect(lpo)) {
          incorrects.push("Дата крайних сроков мероприятия превышает 2 года");
        }

        /* Очаг */
        if (
          (lpo.freqDiseaseList.length || lpo.freqPestList.length) &&
          (!lpo.pest_core_number ||
            !lpo.pest_core_type_id ||
            !lpo.pest_core_phase_id)
        ) {
          incorrects.push("Очаг");
        }
      }
      if (['1','2','3','4','5','7'].includes(lpo.inspection_type_id)) {
        if (!lpo.decline_year_from) {
          incorrects.push("Время ослабления, повреждения насаждения");
        }
        if (!lpo.age_group) {
          incorrects.push("Группа возраста");
        }
        if (lpo.tax_accordance !== "t") {
          if (
            !lpo.disparity_reason ||
            !lpo.bonitet_id_new ||
            !lpo.forest_type_new
          ) {
            incorrects.push(
              "При несоответствии ТО необходимо заполнить поля причины несоответствия, бонитета, и типа леса"
            );
          }
        }
      }
      if (
        lpo.inspection_type_id === "1" ||
        lpo.inspection_type_id === "2" ||
        lpo.inspection_type_id === "3" ||
        lpo.inspection_type_id === "4"
      ) {
        /* Перечет */
        if (!lpo.modelTrees.length || lpo.modelTrees[0].is_draft === "t") {
          incorrects.push(
            'Нажмите кнопку "Закрыть редактирование" в блоке Модельные деревья'
          );
        }
      }

      if (lpo.inspection_type_id === "5") {
        if (+lpo.vbPct < 50) {
          incorrects.push("Бурелом ветровал > 50%");
        }
      }

      if (lpo.inspection_type_id === "1" && lpo.checkSPlot !== "t") {
        incorrects.push("Площадь выделенных лент недостаточна");
      }

      if (lpo.checkProfMzlFitsSks !== "t" && !["7","10", "9"].includes(lpo.inspection_type_id)) {
        incorrects.push(
          "Назначение профилактических мероприятий возможно только при СКС насаждения 2,51 и более"
        );
      }

      if (lpo.inspection_type_id === "4" && lpo.checkKppTreeAmount !== "t") {
        incorrects.push("Среднее количество деревьев на 1й кпп менее 15");
      }

      return incorrects;
    },
    _isMzlPeriodToCorrect(lpo) {
      if (!lpo.mzl_period_to) {
        return true;
      }

      const lpo_year = new Date(lpo.inspection_date).getFullYear();
      const lpo_month = new Date(lpo.inspection_date).getMonth();
      const lpo_day = new Date(lpo.inspection_date).getDate();

      const mzl_year = new Date(lpo.mzl_period_to).getFullYear();
      const mzl_month = new Date(lpo.mzl_period_to).getMonth();
      const mzl_day = new Date(lpo.mzl_period_to).getDate();

      if (+mzl_year - +lpo_year > 2) {
        return false;
      } else if (+mzl_year - +lpo_year < 2) {
        return true;
      }

      if (+mzl_month > +lpo_month) {
        return false;
      } else if (+mzl_month < +lpo_month) {
        return true;
      }

      if (+mzl_day > +lpo_day) {
        return false;
      } else if (+mzl_day < +lpo_day) {
        return true;
      } else {
        return true;
      }

      return false;
    },
    /*******************/

    removeLpo() {
      // console.log('remove lpo');
      this.removeCurrentLpo().then((res) => {
        this.$toast.add({
          severity: "success",
          detail: "Обследование успешно удалено",
          life: 10000,
        });
        /*
						обновление текущего обследования происходит
						в LpoData.vue в хуке роутера beforeRouterUpdate
					*/

        let route_obj = null;

        /* если в группе всего одно обследование - переходим к журналу */
        if (this.actLpoList.length === 1) {
          route_obj = {
            name: "journal-lpo",
          };
        } else {
          /* иначе переходим к другому обследованию из группы */
          const nextLpo = this.actLpoList.find(
            (lpo) => lpo.lpo_id !== this.currentLpo.lpo_id
          );

          route_obj = {
            name: "lpo",
            params: {
              lpo_id: nextLpo.lpo_id,
            },
          };
        }

        this.$router.push(route_obj);
      });
    },

    openDraftConfirmation() {
      this.draftConfirmationIsOpen = true;
    },

    openRemoveConfirmation() {
      this.removeConfirmationIsOpen = true;
    },

    toggle() {
      this.open = !this.open;
    },

    linkTo(routeObj) {
      if (routeObj.name === this.$route.name) {
        return;
      }

      this.$router.push(routeObj);
    },

    isSelected(routeObj) {
      return routeObj.name === this.$route.name;
    },

    ...mapActions("lpoData", ["removeCurrentLpo"]),
  },
  mounted() {
    //console.log(this.currentLpo?this.currentLpo.user_id: 0, this.user.id)
    //console.log('lpo_data_sidebar_mounted')
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/constants.scss";

.sidebar__section {
  margin-bottom: 3rem;
}

.section__title {
  cursor: pointer;
  text-align: center;
  border-bottom: 1px solid #bbbfc4;
  font-size: 1.2rem;
  font-weight: bold;
  padding-bottom: 0.7rem;
  margin-bottom: 0.7rem;
}

.section__title:hover {
  // color: #2CC185;
  color: $color-green;
}

ul {
  margin: 0;
}

.section__list-item {
  align-items: center;
  font-size: 1rem;
  display: flex;
  gap: 1rem;
  cursor: pointer;
  padding: 0.3rem;
}

.section__list-item:hover {
  // color: #2CC185;
  color: $color-green;
}

.section__list-item--selected,
.section__list-item:hover.section__list-item--selected {
  color: #fff;
  // background-color: #2cc185;
  background-color: $color-green;
}

.section__list-item-icon {
  font-size: 1.4rem;
}

.section__list-item--danger {
  color: #dc3545;
}
.section__list-item--danger:hover {
  color: #ee6673;
}
</style>

<style lang="scss" scoped>
$sidebar-width: 240px;

.sidebar {
  box-shadow: 0.01rem 0 0.7rem #414141;
  z-index: 20;
  background-color: #eee;
  color: #6c757d;
  position: relative;

  // overflow-y: scroll;
}

.sidebar__content {
  width: 0;
  min-width: 0;
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
  transition: all ease 0.5s;
}

.sidebar--open .sidebar__content {
  width: $sidebar-width;
  min-width: $sidebar-width;
}

.sidebar__wrapper {
  min-width: $sidebar-width;
  padding: 1rem;
  // overflow-y: scroll;
}

.sidebar__toggle-button {
  background-color: rgba(33, 150, 243, 0.5);
  border: none;

  position: absolute;
  right: -3.5rem;
  bottom: 2rem;
}

.p-progress-spinner {
  height: 26px;
  width: 26px;
}
</style>
